"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderSource = exports.OrderProductPriceType = exports.OrderType = exports.OrderDeliveryType = exports.PickingStatus = exports.OrderStatus = void 0;
var OrderStatus;
(function (OrderStatus) {
    /** Order is a draft and can be modified freely */
    OrderStatus["DRAFT"] = "draft";
    /** Order has been placed, but not paid yet */
    OrderStatus["AWAITING_PAYMENT"] = "awaiting_payment";
    /** Order is being prepared for delivery */
    OrderStatus["PREPARATION"] = "preparation";
    /** Order is waiting to be delivered */
    OrderStatus["AWAITING_DELIVERY"] = "awaiting_delivery";
    /** Order is being delivered */
    OrderStatus["DELIVERY_IN_PROGRESS"] = "delivery_in_progress";
    /** Delivery in progress */
    OrderStatus["DELIVERED"] = "delivered";
    /** Delivery failure (customer is not at home, didn't pick it up, etc.) */
    OrderStatus["DELIVERY_FAILURE"] = "delivery_failure";
    /** Cancelled before being shipped */
    OrderStatus["CANCELLED"] = "cancelled";
    /** Order is being returned by the customer (after he received it) */
    OrderStatus["RETURN_IN_PROGRESS"] = "return_in_progress";
    /** Order returned */
    OrderStatus["RETURNED"] = "returned";
    /**When a order got returned but needed to be redespatched because it was faulty or wrong size**/
    OrderStatus["REDESPATCH"] = "redespatched";
    /**Redespatched order with new delivery in progress**/
    OrderStatus["REDESPATCH_DELIVERY_IN_PROGRESS"] = "redespatched_delivery_in_progress";
    /**Redespatched order delivered**/
    OrderStatus["REDESPATCH_DELIVERED"] = "redespatched_delivered";
    /**Redespatched deilvery failed**/
    OrderStatus["REDESPATCH_DELIVERY_FAILURE"] = "redespatched_delivery_failure";
    /**Returned order has been refunded**/
    OrderStatus["REFUNDED"] = "refunded";
    /**Order return requested  **/
    OrderStatus["RETURN_REQUESTED"] = "order_return_requested";
    /**Order refund requested  **/
    OrderStatus["REFUND_REQUESTED"] = "order_refund_requested";
    OrderStatus["FAILED"] = "failed";
    /**Picked statuses */
    OrderStatus["PICKED"] = "picked";
    OrderStatus["PARTIALLY_PICKED"] = "partially_picked";
    OrderStatus["AWAITING_PICKING"] = "awaiting_picking";
    /**Order is awaiting despatch */
    OrderStatus["AWAITING_DESPATCH"] = "awaiting_despatch";
    OrderStatus["CONSIGNMENT_BOOKED"] = "consignment_booked";
    OrderStatus["LABEL_PRINTED"] = "label_printed";
    OrderStatus["DESPATCHED"] = "despatched";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
var PickingStatus;
(function (PickingStatus) {
    PickingStatus["PICKED"] = "picked";
    PickingStatus["PARTIALLY_PICKED"] = "partially_picked";
    PickingStatus["AWAITING_PICKING"] = "awaiting_picking";
    PickingStatus["NOT_PICKED"] = "not_picked";
})(PickingStatus = exports.PickingStatus || (exports.PickingStatus = {}));
var OrderDeliveryType;
(function (OrderDeliveryType) {
    OrderDeliveryType["IN_PERSON"] = "in_person";
    OrderDeliveryType["DELIVERY_ADDRESS"] = "delivery_address";
    OrderDeliveryType["PICKUP_POINT"] = "pickup_point";
})(OrderDeliveryType = exports.OrderDeliveryType || (exports.OrderDeliveryType = {}));
var OrderType;
(function (OrderType) {
    OrderType["DEFAULT"] = "default";
    OrderType["INVOICE"] = "invoice";
    OrderType["QUOTE"] = "quote";
})(OrderType = exports.OrderType || (exports.OrderType = {}));
var OrderProductPriceType;
(function (OrderProductPriceType) {
    OrderProductPriceType["WHOLESALE"] = "wholesale";
    OrderProductPriceType["RETAIL"] = "retail";
})(OrderProductPriceType = exports.OrderProductPriceType || (exports.OrderProductPriceType = {}));
var OrderSource;
(function (OrderSource) {
    OrderSource["MOBILE"] = "mobile";
    OrderSource["WEB"] = "web";
})(OrderSource = exports.OrderSource || (exports.OrderSource = {}));
